import createModel, { prop } from './lib/create_model';

export default createModel({
  modelName: 'CallForward',

  properties: {
    forwardedToNumber: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
